<template>
  <div class="page">
    <!--主页面-->
    <div style="background-color:#fff ; height:100%">
      <!-- frameborder=0 height="580" marginwidth=0 marginheight=0 hspace=0 vspace=0 scrolling=no width="600" -->
      <div
        style="background:url('../../../static/search/roomTopBg.png') ; max-width:7.5rem; height:0.7rem ; width:100% ; z-index:11; "
      ></div>
      <img
        src="../../../static/home/Brand/GoBackCircle.png"
        v-on:click="goback()"
        style="margin:0.3rem 0.1rem 0.1rem 0.3rem ;height:0.7rem;  position:fixed ; z-index:12;"
      >

      <!-- border-radius: 50%; -->
      <iframe :src="$route.query.iframePage" style="width:100%;height:13.3rem"></iframe>

      <div style="height: 0.1rem;"></div>
    </div>

    <!--<div v-if='vo.Status == "0" && g_currentOrder.freeVoucherInfo.useNotSee' v-bind:class="{ 'active': vo.selected }" class='fBtn'></div>-->
  </div>
</template>





<script>
import api from "../../api";
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
import loadListTail from "../../components/loadListTail";
import Scroll from "../../utils/loading";
export default {
  data() {
    return {};
  },
  activated() {},

  methods: {
    ...mapMutations(["setG_currentOrder"]),

    // 后退一页
    goback() {
      // javascript: history.go(-1);

      if (this.$route.query.source == "AndroidAPP") {
        this.$router.push({
          path: this.$route.query.FromRoute + "&source=AndroidAPP"
        });
      } else {
        this.$router.push({ path: this.$route.query.FromRoute });
      }
    }
  }
};
</script>







<style lang="less" scoped>
@import "../../assets/theme.less";

.mu-tabs {
  // 背景色
  background-color: #f5f5f5;
} // 未选中时候的颜色
.mu-tab-link {
  color: #999999;
  font-weight: bold;
} //  选中  分页的
.mu-tab-active {
  color: @primaryColor;
  font-weight: bold;
} // END 顶部标签变换
</style>







// WEBPACK FOOTER //
// OtherPage.vue?3d89edfe